// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BLD8","colMin":"styles_colMin__1GX14"};